/*
  Mixin used on every page component that needs to have project infos
  (basically, all routes starting with /projects/<projectId>)
*/
import { mapState } from 'vuex';

export default  {
  computed: {
    ...mapState(['project','projectId',]),
  },
  methods: {
    getProject () {
      this.$store.dispatch('loadProject', this.$route.params.id).catch(err => {
        this.$emit('raison-event', { type: 'error', messages: [err.messages] });
      });
    },
  },
  created () {
    if (this.$route.params.id) {
      this.$store.dispatch('setProjectId', this.$route.params.id)
    }
    if (this.$route.params.id && (!this.project || (this.project && this.project.id !== this.$route.params.id))) {
      this.getProject();
    }
  },
};
